import { combineReducers } from 'redux'
import { ruleReducer } from './rule'

export { rootSaga as tableRootSaga } from './table.saga'
export * from './rule'
export const tableReducer = combineReducers({ rule: ruleReducer })
